import React from 'react';
import Footer from '../components/reusableComponents/Footer';
import Headers from '../components/reusableComponents/Headers';
import { Container, Grid, Divider, Box } from '@material-ui/core';

const DetailSection = () => {
	return (
		<>
			<Headers />
			<Divider />
			<Container style={{ marginTop: 20 }}>
				<Grid container spacing={4}>
					<Grid item xs={8}>
						<h2>Women's Special Shimla Manali</h2>
						<span>7 Days - 1 Country | 4 Cities</span>
						<img
							src='https://img.veenaworld.com/group-tours/india/himachal-pradesh/hpwi/hpsp-bnn-hpwi-2712023.jpg'
							style={{ width: '100%', borderRadius: 15 }}
						/>
						<h4 style={{ marginTop: 20 }}>Package Includes</h4>
						<Grid
							container
							style={{ color: 'grey', marginBottom: 20, marginTop: 20 }}
							spacing={2}>
							{Array.from(Array(5)).map(() => {
								return (
									<Grid item xs={2}>
										<Box
											style={{
												textAlign: 'center',
												padding: '20px',
												border: '1px solid lightgray',
												borderRadius: '12px',
												background: 'white',
											}}>
											<i class='fa-solid fa-hotel'></i>
											<p>Hotels</p>
										</Box>
									</Grid>
								);
							})}
						</Grid>
						<h4 style={{ marginTop: 20 }}>Detailed Tour Price</h4>
						<Box
							style={{
								display: 'flex',
								justifyContent: 'space-between',
								border: '1px solid',
								padding: '20px',
								borderBottom: 'none',
								borderTopLeftRadius: 5,
								borderTopRightRadius: 5,
							}}>
							<span>Room Type</span>
							<span>Basic Price</span>
						</Box>
						<Box
							style={{
								display: 'flex',
								justifyContent: 'space-between',
								border: '1px solid',
								padding: '20px',
								borderBottomLeftRadius: 5,
								borderBottomRightRadius: 5,
							}}>
							<span>Twin Sharing</span>
							<span>₹ 85645</span>
						</Box>
						<br />
						<br />
						<br />
					</Grid>
					<Grid
						item
						xs={4}
						style={{
							boxShadow: '0px 10px 15px -3px rgba(0,0,0,0.1)',
							// padding: 60,
						}}>
						<Grid container spacing={4}>
							<Grid item xs={6}>
								<Box
									style={{
										border: '1px solid grey',
										padding: '6px',
										textAlign: 'center',
										borderRadius: '5px',
									}}>
									<span style={{ fontSize: 20 }}>Enquiry Now</span>
								</Box>
							</Grid>
							<Grid item xs={6}>
								<Box
									style={{
										border: '1px solid grey',
										padding: '6px',
										textAlign: 'center',
										borderRadius: '5px',
									}}>
									<span style={{ fontSize: 20 }}>Book Now</span>
								</Box>
							</Grid>
						</Grid>
						{/* <Box style={{ border: '1px solid grey' }}>
								<span>Enquiry</span>
							</Box>
							<Box style={{ border: '1px solid grey' }}>
								<span>Book Now</span>
							</Box> */}
					</Grid>
				</Grid>
			</Container>
			<Footer />
		</>
	);
};

export default DetailSection;
